/** «Лиды по номерам» — ровно то, что отдаёт `GET /api/leads/phones`. */
import { apiFetch, query } from "@/lib/api";

export type Outcome = "out_talk" | "in_talk" | "chat" | "tried" | "deal_no_contact" | "untouched";

export const OUTCOME_LABEL: Record<Outcome, string> = {
  untouched: "Не звонили",
  deal_no_contact: "В сделку без связи",
  tried: "Не дозвонились",
  chat: "Связь в чате",
  in_talk: "Сам позвонил",
  out_talk: "Дозвонились",
};

export type Attempt = { at: string; talk: boolean; sec: number };

export type PhoneRow = {
  phone: string;
  leads: { lead_id: number; created: string; source: string; status: string; deal_id: number | null }[];
  created: string;
  status: string;
  outcome: Outcome;
  first_out: string | null;
  first_out_min: number | null;
  out: number;
  out_talk: number;
  in_talk: number;
  attempts: Attempt[];
};

export type LeadPhones = {
  period: { from: string; to: string };
  work_hours: string;
  funnel: { leads: number; valid_phone: number; in_work: number; phones: number };
  outcomes: Record<Outcome, number>;
  attempts: Record<"0" | "1" | "2" | "3" | "4+", number>;
  first_out: { count: number; mean: number | null; median: number | null; p90: number | null };
  phones: PhoneRow[];
};

export function loadLeadPhones(from: string, to: string): Promise<LeadPhones> {
  return apiFetch<LeadPhones>(`/api/leads/phones${query({ from, to })}`);
}

/** ГГГГ-ММ-ДД на `back` дней назад по локальному календарю. */
export function daysAgo(back: number): string {
  const d = new Date();
  d.setDate(d.getDate() - back);
  return d.toLocaleDateString("sv-SE");
}
